import "./App.css";
import "./assets/custom.css";
import { Helmet } from "react-helmet-async";
import Admin from "./Layouts/Admin";
import Users from "./pages/user/user.jsx";
import Users2 from "./pages/user/user2.jsx";
import UsersTest from "./pages/user/user-test.jsx";
import TwoFA from "./pages/auth/TwoFA";
import { useSelector } from "react-redux";
import Login from "./pages/auth/Login.jsx";
import Page404 from "./pages/404page/404page";
import TimeOff from "./pages/timeOff/timeOff";
import TimeOffs from "./components/TimeOff/TimeOffOverview";
import { ToastContainer } from "react-toastify";
import Invoices from "./pages/invoices/invoices.jsx";
import Dashboard from "./pages/dashboard/dashboard.jsx";
import ResetPassword from "../src/pages/auth/ResetPass";
import ForgetPassword from "./pages/auth/ForgetPassword";
import OnboardCompanyDetails from "./pages/onboarding/OnboardingCompanyDetails.jsx";
import NewBank from "./components/User/Bank/newBank.jsx";
import TimeTracker from "./pages/timeTracker/timeTracker";
import ActivityLog from "./pages/activityLog/activityLog";
import InvoiceSingle from "./pages/invoices/invoiceSingle";
import Timer from "./components/TimeTracker/Timer/Timer.jsx";
import UserProfile from "./pages/user/userDetails/userDeatils.jsx";
import InviteRegister from "./pages/user/invite/inviteRegister.jsx";
import InvoiceCreateAuto from "./pages/invoices/invoiceCreateAuto";
import TimeTrackerLayout from "./pages/timeTracker/timeTracker.jsx";
import InvoiceEditManualPage from "./pages/invoices/invoiceEditManual";
import InvoiceCreateManual from "./pages/invoices/invoiceCreateManual";
import UserRegister from "./components/User/UserRegister/UserRegister";
import Company from "./components/AccountSettings/Companies/Company.jsx";
import ProfileSettings from "./pages/user/profileSettings/profileSettings.jsx";
import {
  BrowserRouter as Router,
  Routes,
  Route,
  Navigate,
} from "react-router-dom";
import TimeTrackerTag from "./components/TimeTracker/TimeTrackerTag/TimeTrackerTag.jsx";
import PaymentOption from "./pages/accountSettings/paymentOptions/paymentOption.jsx";
import AccountSettings from "./pages/accountSettings/accountSettings/accountSettings";
import TimeTrackerTeam from "./components/TimeTracker/TimeTrackerTeam/TimeTrackerTeam.jsx";
import TimeTrackerClient from "./components/TimeTracker/TimeTrackerClient/TimeTrackerClient.jsx";
import TimeTrackerProject from "./components/TimeTracker/TimeTrackerProject/TimeTrackerProject.jsx";
import TimeTrackerOverview from "./components/TimeTracker/TimeTrackerOverview/TimeTrackerOverview.jsx";
import TimeTrackerTeamMember from "./components/TimeTracker/TimeTrackerTeam/TimeTrackerTeamMembers/TimeTrackerTeamMembers.jsx";
import TimeTrackerTeamTypeOfLeave from "./components/TimeTracker/TimeTrackerTeam/TimeTrackerTeamTypeOfLeave/TimeTrackerTeamTypeOfLeave.jsx";
import TimeTrackerTeamDepartment from "./components/TimeTracker/TimeTrackerTeam/TimeTrackerTeamDepartment/TimeTrackerTeamDepartment.jsx";
import ClientOverview from "./pages/Clients/clientOverview.jsx";
import ClientOverviewDetails from "./pages/Clients/ClientDetails";
import ClientProfileSection from "./pages/Clients/Details/ClientDetailProfile.jsx";
import ClientDetailLayout from "./pages/Clients/ClientDetailsLayout/ClientDetailsLayout.jsx";
import VendorOverview from "./pages/Vendors/VendorOverview.jsx";
import VendorOverviewDetails from "./pages/Vendors/VendorDetails";
import VendorProfileSection from "./pages/Vendors/Details/VendorDetailProfile.jsx";
import VendorProfileViewSection from "./pages/Vendors/Details/VendorProfileView.jsx";
import VendorDetailLayout from "./pages/Vendors/VendorDetailsLayout/VendorDetailsLayout.jsx";
import React, { useState, useEffect } from "react";
import Project from "./pages/projects/Project.jsx";
import ProjectDetails from "./pages/projects/details/Details.jsx";
import Document from "./pages/documents/Document.jsx";
import Setup from "./pages/Clients/SetUp/Setup.jsx";
import Alerts from "./pages/Clients/ClientAlerts/ClientAlerts.jsx";
import TimeZoneModal from "./components/Modal/SetDefaultModal.jsx";

import TestPage from "./components/Test/Test.jsx";
import ClientInvoiceSection from "./pages/Clients/Details/ClientDetailInvoices.jsx";
import ClientInvoiceCreate from "./components/Clients/ClientInvoice/ClientInvoiceCreate/ClientInvoiceCreate.jsx";
import ClientInvoiceSingle from "./components/Clients/ClientInvoice/ClientInvoicesSingle/ClientInvoiceSingle.jsx";
import ClientInvoiceEdit from "./components/Clients/ClientInvoice/ClientInvoiceEdit/ClientInvoiceEdit.jsx";
import ClientInviteRegister from "./pages/Clients/ClientInvite/ClientInviteRegister.jsx";
import ClientInvoice from "./pages/Clients/ClientInvoice/ClientInvoice.jsx";
import ClientsProjects from "./pages/Clients/ClientProject/ClientsProjects.jsx";
import Equipment from "./pages/equipment/equipment.jsx";
import ExpenseOverview from "./pages/expense/expenseOverview.jsx";
import ExpenseSingle from "./pages/expense/expenseSingle.jsx";
import CreateExpense from "./pages/expense/expenseCreate.jsx";
import EditExpense from "./pages/expense/expenseEdit.jsx";

import VendorInvoiceSection from "./pages/Vendors/Details/VendorDetailInvoices.jsx";
import VendorInvoiceCreate from "./components/Vendors/VendorInvoice/VendorInvoiceCreate/VendorInvoiceCreate.jsx";
import VendorInvoiceSingle from "./components/Vendors/VendorInvoice/VendorInvoicesSingle/VendorInvoiceSingle.jsx";
import VendorInvoiceEdit from "./components/Vendors/VendorInvoice/VendorInvoiceEdit/VendorInvoiceEdit.jsx";
import VendorInviteRegister from "./pages/Vendors/VendorInvite/VendorInviteRegister.jsx";
import VendorInvoice from "./pages/Vendors/VendorInvoice/VendorInvoice.jsx";

import ReportingOverview from "./pages/Reporting/ReportingOverview.jsx";
import ReportingClients from "./pages/Reporting/ReportingClients.jsx";
import ReportingFinancial from "./pages/Reporting/ReportingFinancial.jsx";
import ReportingPersonnel from "./pages/Reporting/ReportPersonnel.jsx";
import ReportingServices from "./pages/Reporting/ReportingServices.jsx";
import ReportingFinancialExpense from "./components/Reporting/ReportingFinancial/ReportingExpense";
import ReportingFinancialRevenue from "./components/Reporting/ReportingFinancial/ReportingRevenue.jsx";
import ReportingFinancialOverview from "./components/Reporting/ReportingFinancial/ReportingFinancialOverview.jsx";
import UserEquipment from "./pages/equipment/userEquipment.jsx";
import EquipmentCategory from "./pages/equipment/equipmentCategory/eqpCategory.jsx";
import ExpCategoryLayout from "./pages/expense/expCategory/expCategoryLayout.jsx";
import CreateTimeOff from "./pages/timeOff/TimeOffCreate";
import TypeOfLeave from "./components/TimeOff/element/typeOfLeave.jsx";
import ReportingReimbursement from "./components/Reporting/ReportingPersonal/ReportingReimbursement.jsx";
import ReportingTimeWorked from "./components/Reporting/ReportingPersonal/ReportingTimeWorked.jsx";
import ReportingTimeOffRequest from "./components/Reporting/ReportingPersonal/ReportingTimeOffRequest.jsx";
import OnboardingLanding from "./pages/onboarding/landingPage/LangingPage.jsx";
import OnboardingEmailVerification from "./pages/onboarding/landingPage/EmailVerification.jsx";
import OnBoardRegisteration from "./pages/onboarding/registeration/OnboardingCompanyDetails.jsx";
import VendorDashboard from "./pages/Vendors/VendorDashboard.jsx";
import VendorBankSection from "./pages/Vendors/Details/VendorDetailBank.jsx";
import ReportingClientOverview from "./components/Reporting/ClientReport/ReportingClientOverview.jsx";
import ReportingClientTimeWorked from "./components/Reporting/ClientReport/ReportingClientTimeWorked.jsx";
import Home from "./pages/home/home.jsx";
import ClientDashboard from "./pages/Clients/ClientDashboard.jsx";
import MyTeamTabModule from "./pages/user/myteam.jsx";
import OtpVerification from "./pages/home/emailLogin/otpVerification.jsx";
import AppRegister from "./pages/home/emailLogin/register.jsx";
import MasterLogin from "./pages/masterAuth/MasterLogin.jsx";
import MasterUserLayout from "./Layouts/MasterUserLayout.js";
import MasterDashboard from "./pages/master/dashboard/dashboard.jsx";
import Tenants from "./pages/master/tenants/TenantOverview.jsx";
import TenantInviteRegister from "./pages/master/tenants/TenantInviteRegister.jsx";
import CheckEmail from "./pages/auth/CheckEmail.jsx";
import CheckSubDomain from "./pages/auth/CheckSubDomain.jsx";
import GoogleLoad from "./pages/home/googleLogin/GoogleLoad.jsx";
import GoogleLoginTeams from "./pages/home/emailLogin/googleLoginTeams.jsx";
import GoogleLoginTeamsVerify from "./pages/home/emailLogin/googleLoginTeamsVerify.jsx"
import MasterForgetPassword from "./pages/masterAuth/MasterForgetPassword.jsx";
import MasterResetPass from "./pages/masterAuth/MasterResetPass.jsx";
import MasterTwoFA from "./pages/masterAuth/MasterTwoFA.jsx";
import MasterUsers from "./pages/master/users/MasterUserOverview.jsx";
import MasterUserDeatils from "./pages/master/users/MasterUserDetails/MasterUserDeatils.jsx";
import MasterInviteRegisteration from "./pages/master/users/invite/MasterInviteRegisteration.jsx";
import MasterProfileSettings from "./pages/master/profileSettings/masterProfileSettings.jsx";
import MasterUserRegister from "./components/Master/MasterUsers/MasterUserRegister/MasterUserRegister.jsx";
import MasterTenantDetails from "./components/Master/MasterTenants/MasterTenantDetails.jsx";
import MasterTenantRegister from "./components/Master/MasterTenants/MasterTenantRegister.jsx";
import MasterSubscriptionOvervirew from "./pages/master/subscription/SubscriptionOverview";
import MasterSubscriptionEdit from "./pages/master/subscription/SubscriptionEdit";
import MasterSubscriptionAdd from "./pages/master/subscription/SubscriptionAdd";
import MasterTenantInviteHistory from "./pages/master/tenants/TenantInviteHistory";
import CronJobsOverview from "./pages/master/cronJobs/CronJobsOverview.jsx";
import SubscriptionSuccess from "./pages/subscription/SubscriptionSuccess";
import SubscriptionCancel from "./pages/subscription/SubscriptionCancel";
import Expense from "./pages/expense/expense.jsx";
import EquipmentLayout from "./pages/equipment/equipmentLayout.jsx";
import SubdomainGuard from './components/SubdomainGuard';
import ScrollToTop from "./components/SccrollTop/ScrollTop";
import Calendar from "../src/components/Calender/Calender.jsx";
import ChristmasAnimation from "./components/Animations/Christmas/ChristmasAnimation.jsx";
import HrDocuments from "./components/AccountSettings/HrDocuments/HrDocuments.jsx";
import TimeOffSingle from "./pages/timeOff/timeOffSingle.jsx";
// test
import TimerTest from "./components/TimeTracker/Timer/Timer_test.jsx";
import DocumentCategory from "./components/AccountSettings/HrDocuments/element/documentCategory.jsx";
import Documents from "./pages/HrDocument/HrDocument.jsx";
import EventAttendanceSuccess from "./components/Calender/EventAttendanceStatus/EventAttendanceSuccess.jsx";
import EventAttendanceDeclineSuccess from "./components/Calender/EventAttendanceStatus/EventAttendanceDeclineSuccess.jsx";
import EventAttendanceError from "./components/Calender/EventAttendanceStatus/EventAttendanceError.jsx";
import { useTimezoneCheck } from "./hooks/useTimezoneCheck";
import ErrorBoundary from "./components/ErrorBoundary";

function LocationAwareErrorBoundary({ children }) {
  return <ErrorBoundary>{children}</ErrorBoundary>;
}

function App() {

  const { user } = useSelector((state) => state.auth);
  const { masterUser } = useSelector((state) => state.masterAuth);
  const { appSettings } = useSelector((state) => state.appSettings);
  const [showTimeZoneModal, setShowTimeZoneModal] = useState(false);
  const alertState = true;
  const [alertFrom, setAlertFrom] = useState(null);
  const [timeZones, setTimeZones] = useState([]);
  const [zoneChangeConfirm, setZoneChangeConfirm] = useState(localStorage.getItem("zoneChangeConfirm") === "true" ? true : null);
  const faviconFileName = appSettings && appSettings.favIcon;
  const role = user ? user.userType : null;
  const userCat = user ? user.userCategory : null;
  const SUPER_ADMIN = 1;
  const ADMIN = 2;
  const USER = 3;
  const BUSSINESS = 4;
  const PROJECT_MANAGER = 6;
  const TEAM_MANAGER = 7;
  const INDIVIDUAL = 1;
  const BUSSI = 2;
  const VENDOR = 3;
  const CLIENT = 4;
  const auth = user ? true : false;
  const masterAuth = masterUser ? true : false;

  const Redirect = () => {
    if (!auth) {
      return <Navigate to="/" replace={true} />;
    }
    return userCat === VENDOR ? (
      <Navigate to="/vendor/dashboard" replace={true} />
    ) : userCat === CLIENT ? (
      <Navigate to="/client/dashboard" replace={true} />
    ) : (
      <Navigate to="/user/dashboard" replace={true} />
    );
  };

  const MasterUserRedirect = () => {
    if (!masterAuth) {
      return <Navigate to="/master-user/login" replace={true} />;
    }
    return (
      <Navigate to="/master-user/dashboard" replace={true} />
    );
  };

  useTimezoneCheck({
    user,
    auth,
    zoneChangeConfirm,
    setZoneChangeConfirm,
    setAlertFrom,
    setShowTimeZoneModal,
    setTimeZones,
  });

  const checkToken = () => {
    try {
      const localUser = localStorage.getItem("user");

      // If nothing in localStorage
      if (!localUser) {
        console.error("No user found in localStorage");
        return false;
      }

      let parsedUser;

      try {
        parsedUser = JSON.parse(localUser);
      } catch (err) {
        console.error("Failed to parse user from localStorage:", err);
        return false;
      }

      // If token doesn't exist in parsed data
      if (!parsedUser?.token) {
        console.error("Token missing in localStorage user object");
        return false;
      }

      if (!user?.token) {
        console.error("Token missing in current user object");
        return false;
      }
      return parsedUser.token === user.token;

    } catch (error) {
      console.error("Unexpected error during token check:", error);
      return false;
    }
  };

  const checkMasterToken = () => {
    try {
      const localMasterUser = localStorage.getItem("masterUser");

      // No value in localStorage
      if (!localMasterUser) {
        console.error("No masterUser found in localStorage");
        return false;
      }

      let parsedMasterUser;

      // Safely parse JSON
      try {
        parsedMasterUser = JSON.parse(localMasterUser);
      } catch (err) {
        console.error("Failed to parse masterUser from localStorage:", err);
        return false;
      }

      // Validate token existence
      if (!parsedMasterUser?.token) {
        console.error("Token missing in localStorage masterUser object");
        return false;
      }

      if (!masterUser?.token) {
        console.error("Token missing in current masterUser object");
        return false;
      }

      // Compare tokens
      return parsedMasterUser.token === masterUser.token;

    } catch (error) {
      console.error("Unexpected error during master token check:", error);
      return false;
    }
  };

  const locationEnable = async () => {
    try {
      if (typeof navigator === "undefined") return;
      if (!navigator.geolocation) return;
      if (!navigator.permissions || !navigator.permissions.query) {
        navigator.geolocation.getCurrentPosition(() => {});
        return;
      }
      const permission = await navigator.permissions.query({
        name: "geolocation",
      });
      if (permission.state === "granted") {
        navigator.geolocation.getCurrentPosition(() => {});
      }
    } catch (err) {
      // eslint-disable-next-line no-console
      console.log("Error:", err);
      global.config?.slackMessage?.(err.toString());
    }
  };
  useEffect(() => {
    locationEnable();
  }, []);

  useEffect(() => {
    const href = faviconFileName && faviconFileName !== "null"
      ? `/uploads/orgiFavIcon/${faviconFileName}?v=${Date.now()}`
      : "#";

    let iconLink = document.querySelector("link[rel='icon']");
    if (!iconLink) {
      iconLink = document.createElement("link");
      iconLink.rel = "icon";
      document.head.appendChild(iconLink);
    }
    iconLink.href = href;

    let appleLink = document.querySelector("link[rel='apple-touch-icon']");
    if (!appleLink) {
      appleLink = document.createElement("link");
      appleLink.rel = "apple-touch-icon";
      document.head.appendChild(appleLink);
    }
    appleLink.href = href;
  }, [faviconFileName]);

  return (
    <div className="App">
      <>
        <Helmet>
          <meta charset="utf-8" />
          <meta name="robots" content="noindex" />

          <meta name="viewport" content="width=device-width, initial-scale=1" />
          <meta name="theme-color" content="#000000" />
          {appSettings &&
            appSettings.seoTitle &&
            appSettings.seoTitle !== "null" &&
            appSettings.seoTitle !== null ? (
            <meta name="title" content={appSettings.seoTitle} />
          ) : (
            <meta name="title" content="TalentOn" />
          )}
          {appSettings &&
            appSettings.metaDescription &&
            appSettings.metaDescription !== "null" &&
            appSettings.metaDescription !== null ? (
            <meta name="description" content={appSettings.metaDescription} />
          ) : (
            <meta name="description" content="TalentOn" />
          )}

          <link rel="manifest" href="../public/manifest.json" />
          <link rel="stylesheet" href="https://use.typekit.net/eel7ejk.css" />
          <link rel='stylesheet' href='https://fonts.googleapis.com/css?family=Arvo' />

          <title>Talenton</title>
        </Helmet>
          <Router>
            <ScrollToTop />
            <LocationAwareErrorBoundary>
            <Routes>
            <Route path="on-boarding" element={<OnboardingLanding />} />
            <Route path="/event-attendance-success" element={<EventAttendanceSuccess />} />
            <Route path="/event-attendance-decline-success" element={<EventAttendanceDeclineSuccess />} />
            <Route path="/event-attendance-error" element={<EventAttendanceError />} />
            <Route path="/subscription/success" element={<SubscriptionSuccess />} />
            <Route path="/subscription/cancel" element={<SubscriptionCancel />} />
            <Route path="on-boarding/email-verification" element={<OnboardingEmailVerification />} />
            <Route path="onboard/invite/register/:encodedAppId/:usertype/:email" element={!auth ? <OnBoardRegisteration /> : Redirect()} />

            <Route path="/" element={!auth ? <SubdomainGuard> <CheckEmail /> </SubdomainGuard> : Redirect()} />
            <Route path="auth" element={!auth ? <Home /> : Redirect()} />
            <Route path="/login" element={(!auth) ? <SubdomainGuard> <Login /> </SubdomainGuard> : Redirect()} />

            <Route path="auth/myteam/:subdomain/:email" element={!auth ? <SubdomainGuard><CheckSubDomain /></SubdomainGuard> : Redirect()} />
            <Route path="forget-password" element={!auth ? <SubdomainGuard><ForgetPassword /></SubdomainGuard> : Redirect()} />
            <Route path="passwords/reset/:token/:email" element={!auth ? <ResetPassword /> : Redirect()} />
            <Route path="2fa" element={!auth ? <TwoFA /> : Redirect()} />
            <Route path="invite/register/:encodedAppId/:usertype/:email" element={!auth ? <InviteRegister /> : Redirect()} />

            <Route path="client/invite/register/:encodedAppId/:cliInvEmail" element={!auth ? <ClientInviteRegister /> : Redirect()} />
            <Route path="vendor/invite/register/:encodedAppId/:venInvEmail" element={!auth ? <VendorInviteRegister /> : Redirect()} />
            <Route path="onboarding/company-details" element={auth && checkToken() ? <OnboardCompanyDetails /> : Redirect()} />

            <Route path="/master-user/login" element={!masterAuth ? <MasterLogin /> : MasterUserRedirect()} />
            <Route path="/master-user/forget-password" element={!masterAuth ? <MasterForgetPassword /> : MasterUserRedirect()} />
            <Route path="/master-user/passwords/reset/:token/:email" element={!masterAuth ? <MasterResetPass /> : MasterUserRedirect()} />
            <Route path="/master-user/2fa" element={!masterAuth ? <MasterTwoFA /> : MasterUserRedirect()} />
            <Route path="/master/user/invite/register/:usertype/:email" element={!masterAuth ? <MasterInviteRegisteration /> : MasterUserRedirect()} />

            <Route path="/master-user" element={masterAuth && checkMasterToken() ? (<MasterUserLayout />) : (MasterUserRedirect())}>
              <Route path="dashboard" element={masterAuth && checkMasterToken() ? <MasterDashboard /> : MasterUserRedirect()} />
              <Route path="tenants/list" element={masterAuth && checkMasterToken() ? <Tenants /> : MasterUserRedirect()} />
              <Route path="tenants/register" element={masterAuth && checkMasterToken() ? <MasterTenantRegister /> : MasterUserRedirect()} />
              <Route path="tenants/invite-history" element={masterAuth && checkMasterToken() ? <MasterTenantInviteHistory /> : MasterUserRedirect()} />
              <Route path="subscriptions" element={masterAuth && checkMasterToken() ? <MasterSubscriptionOvervirew /> : MasterUserRedirect()} />
              <Route path="subscriptions/edit/:encryptedPlanId" element={masterAuth && checkMasterToken() ? <MasterSubscriptionEdit /> : MasterUserRedirect()} />
              <Route path="subscriptions/add" element={masterAuth && checkMasterToken() ? <MasterSubscriptionAdd /> : MasterUserRedirect()} />
              <Route path="tenant/profile/:encodedSubDomain" element={(masterAuth && checkMasterToken()) ? (<MasterTenantDetails />) : (MasterUserRedirect())} />
              <Route path="list" element={masterAuth && checkMasterToken() ? <MasterUsers /> : MasterUserRedirect()} />
              <Route path="register" element={masterAuth && checkMasterToken() ? (<MasterUserRegister />) : (Redirect())} />
              <Route path="profile/:encryptedId" element={(masterAuth && checkMasterToken()) ? (<MasterUserDeatils />) : (MasterUserRedirect())} />
              <Route path="profile/settings" element={masterAuth && checkMasterToken() ? <MasterProfileSettings /> : Redirect()} />
              <Route path="cron-jobs" element={masterAuth && checkMasterToken() ? <CronJobsOverview /> : MasterUserRedirect()} />
            </Route>
            <Route path="/user" element={auth && checkToken() ? <Admin /> : Redirect()}>
              <Route path="dashboard" element={auth && checkToken() && (userCat === INDIVIDUAL || userCat === BUSSI) ? <Dashboard /> : Redirect()} />
              <Route path="account/settings" element={auth && checkToken() && (role === ADMIN || role === SUPER_ADMIN) ? (<AccountSettings />) : (Redirect())} />
              <Route path="invoices" element={auth && checkToken() && (userCat === INDIVIDUAL || userCat === BUSSI) ? <Invoices /> : Redirect()} />
              <Route path="myteam" element={auth && checkToken() && (role === ADMIN || role === SUPER_ADMIN) && (userCat === INDIVIDUAL || userCat === BUSSI) ? (<MyTeamTabModule />) : (Redirect())} >
                <Route path="list" element={auth && checkToken() && (role === ADMIN || role === SUPER_ADMIN) ? (<Users />) : (Redirect())} />
                <Route path="list2" element={auth && checkToken() && (role === ADMIN || role === SUPER_ADMIN) ? (<Users2 />) : (Redirect())} />
                <Route path="department" element={auth && checkToken() && (role === ADMIN || role === SUPER_ADMIN) ? (<TimeTrackerTeamDepartment />) : (Redirect())} />
              </Route>
              {/* test */}
              <Route path="list-test" element={auth && checkToken() && (role === ADMIN || role === SUPER_ADMIN) ? (<UsersTest />) : (Redirect())} />
              {/* test */}
              <Route exact path="register" element={auth && checkToken() && (role === ADMIN || role === SUPER_ADMIN) ? (<UserRegister />) : (Redirect())} />
              <Route path="invoice/view/:id" element={auth && checkToken() && (userCat === INDIVIDUAL || userCat === BUSSI) ? <InvoiceSingle /> : Redirect()} />
              <Route path="invoice/manual/create" element={auth && checkToken() && (userCat === INDIVIDUAL || userCat === BUSSI) ? <InvoiceCreateManual /> : Redirect()} />
              <Route path="invoice/auto/create" element={auth && checkToken() && (userCat === INDIVIDUAL || userCat === BUSSI) ? <InvoiceCreateAuto /> : Redirect()} />
              <Route path="invoice/edit/:encryptedId" element={auth && checkToken() && (userCat === INDIVIDUAL || userCat === BUSSI) ? <InvoiceEditManualPage /> : Redirect()} />
              <Route path="profile/:encryptedId" element={auth && checkToken() && (role === ADMIN || role === SUPER_ADMIN) ? (<UserProfile />) : (Redirect())} />
              <Route path="profile/settings" element={auth && checkToken() ? <ProfileSettings /> : Redirect()} />
              <Route path="accont-settings/payment-options" element={auth && checkToken() && (role === ADMIN || role === SUPER_ADMIN) ? (<PaymentOption />) : (Redirect())} />
              <Route path="bank">
                <Route path="new" element={auth && checkToken() ? <NewBank /> : Redirect()} />
              </Route>
              <Route path="time-tracker" element={auth && checkToken() && (userCat === INDIVIDUAL || userCat === BUSSI) ? <TimeTracker /> : Redirect()} />
              <Route path="time-tracker" element={auth && checkToken() && (userCat === INDIVIDUAL || userCat === BUSSI) ? (<TimeTrackerLayout />) : (Redirect())} >
                <Route path="overview" element={auth && checkToken() && checkToken() ? (<TimeTrackerOverview />) : (Redirect())} />
                <Route path="timer"
                  element={auth && checkToken() &&
                    (role === USER || role === BUSSINESS || role === PROJECT_MANAGER || role === TEAM_MANAGER || role === ADMIN || role === SUPER_ADMIN)
                    ?
                    (<Timer />) : (Redirect())}
                />
                <Route path="timer2"
                  element={auth && checkToken() &&
                    (role === USER || role === BUSSINESS || role === PROJECT_MANAGER || role === TEAM_MANAGER || role === ADMIN || role === SUPER_ADMIN)
                    ?
                    (<TimerTest />) : (Redirect())}
                />
                <Route path="team" element={auth && checkToken() && (role === ADMIN || role === SUPER_ADMIN) ? (<TimeTrackerTeam />) : (Redirect())} >
                  <Route path="members" element={auth && checkToken() && (role === ADMIN || role === SUPER_ADMIN) ? (<TimeTrackerTeamMember />) : (Redirect())} />
                  <Route path="department" element={auth && checkToken() && (role === ADMIN || role === SUPER_ADMIN) ? (<TimeTrackerTeamDepartment />) : (Redirect())} />
                  <Route path="type-of-leave" element={auth && checkToken() && (role === ADMIN || role === SUPER_ADMIN) ? (<TimeTrackerTeamTypeOfLeave />) : (Redirect())} />
                </Route>
                <Route path="client" element={auth && checkToken() && (role === ADMIN || role === SUPER_ADMIN) ? (<TimeTrackerClient />) : (Redirect())} />
                <Route path="projects" element={auth && checkToken() && (role === ADMIN || role === SUPER_ADMIN) ? (<TimeTrackerProject />) : (Redirect())} />
                <Route path="tag" element={auth && checkToken() && (role === ADMIN || role === SUPER_ADMIN) ? (<TimeTrackerTag />) : (Redirect())} />
              </Route>
              <Route path="activity-log/list" element={auth && checkToken() && (role === ADMIN || role === SUPER_ADMIN) ? (<ActivityLog />) : (Redirect())} />
              <Route path="time-off" element={auth && checkToken() && (userCat === INDIVIDUAL || userCat === BUSSI) ? (<TimeOff />) : (Redirect())} >
                <Route path="overview" element={auth && checkToken() && (userCat === INDIVIDUAL || userCat === BUSSI) ? <TimeOffs /> : (Redirect())} />
                <Route path="leave-type" element={auth && checkToken() && (role === ADMIN || role === SUPER_ADMIN) ? (<TypeOfLeave />) : (Redirect())} />
                <Route path="view/:id" element={auth && checkToken() && (userCat === INDIVIDUAL || userCat === BUSSI) ? <TimeOffSingle /> : Redirect()} />
                <Route path="create" element={auth && checkToken() && (userCat === INDIVIDUAL || userCat === BUSSI) ? (<CreateTimeOff />) : (Redirect())} />
              </Route>
              <Route path="expense" element={auth && checkToken() && (role === ADMIN || role === SUPER_ADMIN || role === PROJECT_MANAGER) ? (<Expense />) : (Redirect())} >
                <Route path="overview" element={auth && checkToken() && (role === ADMIN || role === SUPER_ADMIN || role === PROJECT_MANAGER) ? (<ExpenseOverview />) : (Redirect())} />
                <Route path="expense-category" element={auth && checkToken() && (role === ADMIN || role === SUPER_ADMIN || role === PROJECT_MANAGER) ? (<ExpCategoryLayout />) : (Redirect())} />
                <Route path="view/:encryptedId" element={auth && checkToken() && (userCat === INDIVIDUAL || userCat === BUSSI) ? <ExpenseSingle /> : Redirect()} />
                <Route path="edit/:encryptedId" element={auth && checkToken() && (role === ADMIN || role === SUPER_ADMIN || role === PROJECT_MANAGER) ? (<EditExpense />) : (Redirect())} />
              </Route>
              <Route path="expense/create" element={auth && checkToken() && (role === ADMIN || role === SUPER_ADMIN || role === PROJECT_MANAGER) ? (<CreateExpense />) : (Redirect())} />
              <Route path="equipment" element={auth && checkToken() && (role === ADMIN || role === SUPER_ADMIN) ? (<EquipmentLayout />) : (Redirect())} >
                <Route path="overview" element={auth && checkToken() && (role === ADMIN || role === SUPER_ADMIN) ? (<Equipment />) : (Redirect())} />
                <Route path="equipment/category" element={auth && checkToken() && (role === ADMIN || role === SUPER_ADMIN) ? (<EquipmentCategory />) : (Redirect())} />
                <Route path="view/:id" element={auth && checkToken() && (userCat === INDIVIDUAL || userCat === BUSSI) ? <ExpenseSingle /> : Redirect()} />
              </Route>
              <Route path="users/equipment" element={auth && checkToken() && role !== ADMIN && role !== SUPER_ADMIN ? (<UserEquipment />) : (Redirect())} />
              <Route path="app/company" element={auth && checkToken() ? <Company /> : Redirect()} />
              <Route path="calendar" element={auth && checkToken() && (userCat === INDIVIDUAL || userCat === BUSSI) ? <Calendar /> : (Redirect())} />
              <Route path="documents" element={auth && checkToken() ? <Documents /> : (Redirect())} >
                <Route path="overview" element={auth && checkToken() ? <HrDocuments /> : (Redirect())} />
                <Route path="categories" element={auth && checkToken() && (role === ADMIN || role === SUPER_ADMIN) ? (<DocumentCategory />) : (Redirect())} />
              </Route>

            </Route>

            {/* Client section */}
            <Route
              path="/client"
              element={auth && checkToken() && (((role === ADMIN || role === SUPER_ADMIN || role === PROJECT_MANAGER) && (userCat === INDIVIDUAL || userCat === BUSSI)) || userCat === CLIENT) ? <Admin /> : Redirect()}
            >
              {/* <Route path="/client" element={auth && checkToken() ? (<Admin />) : (Redirect())} > */}
              <Route path="dashboard" element={auth && checkToken() && (userCat === CLIENT) ? <ClientDashboard /> : Redirect()} />
              <Route path="overview" element={auth && checkToken() ? <ClientOverview /> : Redirect()} />
              <Route path="details/:encryptedId" element={auth && checkToken() && (role === ADMIN || role === SUPER_ADMIN || role === PROJECT_MANAGER) ? (<ClientOverviewDetails />) : (Redirect())} />
              {/* <Route path="details/:encryptedId" element={auth && checkToken() ? (<ClientOverviewDetails />) : (Redirect())} /> */}
              <Route path="profile" element={auth && checkToken() && ((role === ADMIN || role === SUPER_ADMIN || role === PROJECT_MANAGER) && (userCat === INDIVIDUAL || userCat === BUSSI)) ? (<ClientDetailLayout />) : (Redirect())} >
                <Route path=":encryptedId" element={auth && checkToken() ? (<ClientProfileSection />) : (Redirect())} />
                <Route path="invoices/:encryptedId" element={auth && checkToken() ? (<ClientInvoiceSection />) : (Redirect())} />
              </Route>
              <Route path="invoices" element={auth && checkToken() ? (<ClientDetailLayout />) : (Redirect())} >
                <Route path=":encryptedId" element={auth && checkToken() ? (<ClientInvoiceSection />) : (Redirect())} />
                <Route path="create/:encryptedId" element={auth && checkToken() && ((role === ADMIN || role === SUPER_ADMIN || role === PROJECT_MANAGER) && (userCat === INDIVIDUAL || userCat === BUSSI)) ? <ClientInvoiceCreate /> : Redirect()} />
                <Route path="view/:inv/:encryptedId" element={auth && checkToken() ? <ClientInvoiceSingle /> : Redirect()} />
                <Route path="edit/:inv/:encryptedId" element={auth && checkToken() && ((role === ADMIN || role === SUPER_ADMIN || role === PROJECT_MANAGER) && (userCat === INDIVIDUAL || userCat === BUSSI)) ? <ClientInvoiceEdit /> : Redirect()} />
              </Route>
              <Route path="projects" element={auth && checkToken() && (userCat === INDIVIDUAL || userCat === BUSSI) ? (<ClientDetailLayout />) : (Redirect())} >
                <Route path=":encryptedId" element={auth && checkToken() ? <Project /> : Redirect()} />
                <Route path="details/:projectId/:encryptedId" element={auth && checkToken() ? <ProjectDetails /> : Redirect()} />
              </Route>
              <Route path="documents" element={auth && checkToken() && (userCat === INDIVIDUAL || userCat === BUSSI) ? (<ClientDetailLayout />) : (Redirect())} >
                <Route path=":encryptedId" element={auth && checkToken() ? <Document /> : Redirect()} />
              </Route>
              <Route path="setup" element={auth && checkToken() && (userCat === INDIVIDUAL || userCat === BUSSI) ? (<ClientDetailLayout />) : (Redirect())} >
                <Route path=":encryptedId" element={auth && checkToken() ? <Setup /> : Redirect()} />
              </Route>
              <Route path="alerts" element={auth && checkToken() && (userCat === INDIVIDUAL || userCat === BUSSI) ? (<ClientDetailLayout />) : (Redirect())} >
                <Route path=":encryptedId" element={auth && checkToken() ? <Alerts /> : Redirect()} />
              </Route>
              <Route path="invoice" element={auth && checkToken() ? <ClientInvoice /> : Redirect()} />
              <Route path="project" element={auth && checkToken() ? <ClientsProjects /> : Redirect()} />
            </Route>
            {/* Client section */}

            {/* Vendor section */}
            <Route
              path="/vendor"
              element={auth && checkToken() && (role === ADMIN || role === SUPER_ADMIN || userCat === VENDOR) ? <Admin /> : Redirect()}
            >
              <Route path="dashboard" element={auth && checkToken() && (userCat === VENDOR) ? <VendorDashboard /> : Redirect()} />
              <Route path="overview" element={auth && checkToken() ? <VendorOverview /> : Redirect()} />
              <Route path="details/:encryptedId" element={auth && checkToken() && (role === ADMIN || role === SUPER_ADMIN) ? (<VendorOverviewDetails />) : (Redirect())} />
              <Route path="profile" element={auth && checkToken() && (userCat === INDIVIDUAL || userCat === BUSSI) ? (<VendorDetailLayout />) : (Redirect())}>
                <Route path="view/:encryptedId" element={auth && checkToken() ? (<VendorProfileViewSection />) : (Redirect())} />
                <Route path=":encryptedId" element={auth && checkToken() ? (<VendorProfileSection />) : (Redirect())} />
                <Route path="invoices/:encryptedId" element={auth && checkToken() ? (<VendorInvoiceSection />) : (Redirect())} />
              </Route>
              <Route path="invoices" element={auth && checkToken() ? (<VendorDetailLayout />) : (Redirect())} >
                <Route path=":encryptedId" element={auth && checkToken() ? (<VendorInvoiceSection />) : (Redirect())} />
                <Route path="create/:encryptedId" element={auth && checkToken() ? <VendorInvoiceCreate /> : Redirect()} />
                <Route path="view/:inv/:encryptedId" element={auth && checkToken() ? <VendorInvoiceSingle /> : Redirect()} />
                <Route path="edit/:inv/:encryptedId" element={auth && checkToken() ? <VendorInvoiceEdit /> : Redirect()} />
              </Route>
              <Route path="banks" element={auth && checkToken() ? (<VendorDetailLayout />) : (Redirect())} >
                <Route path=":encryptedId" element={auth && checkToken() ? (<VendorBankSection />) : (Redirect())} />
              </Route>
              <Route path="invoice" element={auth && checkToken() ? <VendorInvoice /> : Redirect()} />
            </Route>
            {/* Vendor section */}

            {/* Report section */}
            <Route
              path="/report"
              element={auth && checkToken() && (role === ADMIN || role === SUPER_ADMIN) ? <Admin /> : Redirect()}
            >
              <Route path="overview" element={auth && checkToken() ? <ReportingOverview /> : Redirect()} />
              <Route path="clients" element={auth && checkToken() ? <ReportingClients /> : Redirect()} >
                <Route path="overview" element={auth && checkToken() ? (<ReportingClientOverview />) : (Redirect())} />
                <Route path="timeworked" element={auth && checkToken() ? (<ReportingClientTimeWorked />) : (Redirect())} />
              </Route>
              <Route path="financial" element={auth && checkToken() ? <ReportingFinancial /> : Redirect()} >
                <Route path="expense" element={auth && checkToken() ? (<ReportingFinancialExpense />) : (Redirect())} />
                <Route path="revenue" element={auth && checkToken() ? (<ReportingFinancialRevenue />) : (Redirect())} />
                <Route path="overview" element={auth && checkToken() ? (<ReportingFinancialOverview />) : (Redirect())} />
              </Route>
              <Route path="personnel" element={auth && checkToken() ? <ReportingPersonnel /> : Redirect()} >
                <Route path="timeoffrequest" element={auth && checkToken() ? (<ReportingTimeOffRequest />) : (Redirect())} />
                <Route path="reimbursement" element={auth && checkToken() ? (<ReportingReimbursement />) : (Redirect())} />
                <Route path="timeworked" element={auth && checkToken() ? (<ReportingTimeWorked />) : (Redirect())} />
              </Route>
              <Route path="services" element={auth && checkToken() ? <ReportingServices /> : Redirect()} />
            </Route>
            {/* Report section */}

            <Route path="test" element={<TestPage />} />

            <Route path="home" element={<Home />} />
            <Route path="*" element={<Page404 />} />

            {/* app registration */}
            <Route path="app/otp/verification/:email" element={<OtpVerification />} />
            <Route path="app/register/:email/:otp" element={<AppRegister />} />
            <Route path="app/register/:email" element={<TenantInviteRegister />} />
            <Route path="app/google/auth/:id" element={<GoogleLoad />} />
            <Route path="app/google/auth/team/:encodedEmail" element={<GoogleLoginTeams />} />
            <Route path="app/google/auth/team/verify/:token" element={<GoogleLoginTeamsVerify />} />
            {/* end app registration */}

            </Routes>

            {auth && checkToken() && (
              <TimeZoneModal
                showTimeZoneModal={showTimeZoneModal}
                state={alertState}
                from={alertFrom}
                data={timeZones}
                onClose={() => {
                  console.log("onClose called from App");
                  setShowTimeZoneModal(false);
                }}
              />
            )}

          </LocationAwareErrorBoundary>
          </Router>
        <ToastContainer />
        <ChristmasAnimation />
      </>
    </div>
  );
}

export default App;
